module.exports = __webpack_public_path__ + "static/img/banner.765b232.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/banner.jpg
// module id = VyuI
// module chunks = 36